import { useSuspenseQuery } from "@tanstack/react-query"

import queryClient from "@/api/client"
import MenuAppDAO from "@/entities/app/menu/menu.dao"
import { EventDto } from "@/entities/app/menu/menu.dto"

import MenuAppSettings from "./MenuAppSettings"



const menuAppDao = new MenuAppDAO

interface MenuAppSettingsContainerProps {
  id: string
  onChange?(): void
}

function MenuAppSettingsContainer(props: MenuAppSettingsContainerProps) {
  const { data: menuApp } = useSuspenseQuery({
    queryFn: () => menuAppDao.findById(props.id),
    queryKey: [menuAppDao.name, props.id]
  })

  async function onCreateEvent(event: EventDto) {
    const currentEvents = menuApp.events || []
    const updatedEvents = [...currentEvents, event]
    await menuAppDao.assignEvents(props.id, updatedEvents)

    // Invalidate specific menu app query
    queryClient.invalidateQueries({ queryKey: [menuAppDao.name, props.id] })

    // Invalidate location-level queries to update calendar icons
    queryClient.invalidateQueries({
      queryKey: [menuAppDao.name, "location", menuApp.locationId]
    })

    props.onChange?.()
  }

  async function onUpdateEvent(index: number, event: EventDto) {
    const currentEvents = menuApp.events || []
    const updatedEvents = [...currentEvents]
    updatedEvents[index] = event
    await menuAppDao.assignEvents(props.id, updatedEvents)

    // Invalidate specific menu app query
    queryClient.invalidateQueries({ queryKey: [menuAppDao.name, props.id] })

    // Invalidate location-level queries to update calendar icons
    queryClient.invalidateQueries({
      queryKey: [menuAppDao.name, "location", menuApp.locationId]
    })

    props.onChange?.()
  }

  async function onDeleteEvent(index: number) {
    const currentEvents = menuApp.events || []
    const updatedEvents = currentEvents.filter((_, i) => i !== index)
    await menuAppDao.assignEvents(props.id, updatedEvents)

    // Invalidate specific menu app query
    queryClient.invalidateQueries({ queryKey: [menuAppDao.name, props.id] })

    // Invalidate location-level queries to update calendar icons
    queryClient.invalidateQueries({
      queryKey: [menuAppDao.name, "location", menuApp.locationId]
    })

    props.onChange?.()
  }

  return (
    <MenuAppSettings
      app={menuApp}
      onCreateEvent={onCreateEvent}
      onUpdateEvent={onUpdateEvent}
      onDeleteEvent={onDeleteEvent}
      key={props.id}
    />
  )
}

export default MenuAppSettingsContainer
